import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ValidatorForm } from 'react-material-ui-form-validator';

import { 
    Grid,
    Fab,
    Typography,
    Divider,
    Button
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";

import { useForm } from '../../../../hooks/useForm'
import { certificadoForm } from '../../data/values';
import ValidatedDatePicker from '../../../compartidos/ValidatedDatePicker';
import { Documentacion } from '../../../ui/Documentacion/Documentacion';
import { CATEGORIAS_TIPO_DOCUMENTACION, MODULO_APLICACION } from '../../../../utils/constants';
import { DISCAPACIDAD_PERMISOS } from '../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { certificadoInsertStart, deleteCertificadoDisca, deleteFileCertificadoDisca, startUploading } from '../../../../actions/certificados';
import DeleteButtonAbm from '../../../compartidos/abms/DeleteButtonAbm';

export const FormDocumentacionCertificado = ({handleSubmit, certificadoDiscapacidad, afiliado}) => {
    const dispatch = useDispatch();

    const { permisos: permisosUser } = useSelector((state) => state.auth);
    const documentacionCertificado = certificadoDiscapacidad?.imagenCertificado;

    const [
        formValues,,,
        setearValor
    ] = useForm(certificadoForm({idAfiliado: afiliado.id_afiliado, certificadoDiscapacidad}));

    const [fechas, setFechas] = useState({
        fecha: formValues.fecha ? formValues.fecha : null,
        fechaVencimiento: formValues.fechaVencimiento ? formValues.fechaVencimiento : null,
        fechaActualizacion: formValues.fechaActualizacion ? formValues.fechaActualizacion : null,
        fecha2doVencimiento: formValues.fecha2doVencimiento ? formValues.fecha2doVencimiento : null,
    });

    const handleCreateCertificado = () => {
        setFechas({
            fecha: null,
            fechaVencimiento: null,
            fechaActualizacion: null,
            fecha2doVencimiento: null,
        })
        dispatch(certificadoInsertStart(certificadoForm({idAfiliado: afiliado.id_afiliado})));
    }

    const handleDelete = () => {
        dispatch(deleteCertificadoDisca(certificadoDiscapacidad.idItem));
    }

    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit({...formValues});
    };

    ValidatorForm.addValidationRule("isLowerFechaVencimiento", (value) => {
        if (moment(value).isValid()) {
          if(moment(value).subtract(1, 'days') < new Date(fechas.fechaVencimiento))
            return false;
        }
        return true;
    });  

    return (
        <ValidatorForm onSubmit={onSubmit}>
            {certificadoDiscapacidad &&
                <Grid container spacing={1} style={{padding: "0.2em 0"}}>
                    <Grid item xs={12} style={{display: "flex", justifyContent: "center"}} color="primary">
                        <Typography variant='button' style={{textAlign: "center"}}>Documentacion Certificado de Discapacidad</Typography>
                    </Grid>
                    <Grid item xs={12} style={{marginBotton: "1em"}}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2} style={{padding: "1em"}}>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={3} >
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <ValidatedDatePicker
                                                margin="normal"
                                                label="Fecha Emisión"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                fullWidth
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                value={fechas.fecha}
                                                onChange={(date) => {
                                                    setFechas({...fechas, fecha: date});
                                                    setearValor("fecha", date)
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                                validators={[
                                                    "required",
                                                    "isValidDate",
                                                    "isLowerActualDate"
                                                ]}
                                                errorMessages={[
                                                    "Este campo es obligatorio",
                                                    "La fecha ingresada no es valida",
                                                    "La fecha no puede ser superior a la fecha actual"
                                                ]}
                                                maxDate={new Date()}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <ValidatedDatePicker
                                                margin="normal"
                                                label="Fecha de Vencimiento"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                fullWidth
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                disabled={fechas.fechaActualizacion}
                                                value={fechas.fechaVencimiento}
                                                onChange={(date) => {
                                                    setFechas({...fechas, fechaVencimiento: date});
                                                    setearValor("fechaVencimiento", date)
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                                validators={fechas.fechaActualizacion
                                                    ?
                                                        [
                                                        ]
                                                    :
                                                        [
                                                            "required",
                                                            "isValidDate",
                                                            "isHigherActualDate"
                                                        ]
                                                }
                                                errorMessages={fechas.fechaActualizacion
                                                    ?
                                                        [
                                                        ]
                                                    :
                                                        [
                                                            "Este campo es obligatorio",
                                                            "La fecha ingresada no es valida",
                                                            "La fecha no puede ser anterior a la fecha actual"
                                                        ]
                                                }
                                                minDate={new Date()}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <ValidatedDatePicker
                                                margin="normal"
                                                label="Fecha Actualizacion"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                fullWidth
                                                disabled={fechas.fechaVencimiento || fechas.fecha2doVencimiento}
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                value={fechas.fechaActualizacion}
                                                onChange={(date) => {
                                                    setFechas({...fechas, fechaActualizacion: date});
                                                    setearValor("fechaActualizacion", date)
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                                validators={fechas.fechaActualizacion&&
                                                    [
                                                        "isValidDate",
                                                        "isHigherActualDate",
                                                    ]
                                                }
                                                errorMessages={fechas.fechaActualizacion&&
                                                    [
                                                        "La fecha ingresada no es valida",
                                                        "La fecha no puede ser anterior a la fecha actual",
                                                    ]
                                                }
                                                minDate={new Date()}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <ValidatedDatePicker
                                                margin="normal"
                                                label="Fecha 2do Vencimiento"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                fullWidth
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                value={fechas.fecha2doVencimiento}
                                                disabled={fechas.fechaActualizacion}
                                                onChange={(date) => {
                                                    setFechas({...fechas, fecha2doVencimiento: date});
                                                    setearValor("fecha2doVencimiento", date)
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                                validators={fechas.fecha2doVencimiento&&
                                                    [
                                                        "isValidDate",
                                                        "isHigherActualDate",
                                                        "isLowerFechaVencimiento"
                                                    ]
                                                }
                                                errorMessages={fechas.fecha2doVencimiento&&
                                                    [
                                                        "La fecha ingresada no es valida",
                                                        "La fecha no puede ser anterior a la fecha actual",
                                                        "La fecha no puede ser anterior a la fecha de vencimiento"
                                                    ]
                                                }
                                                minDate={new Date()}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <Documentacion 
                                    handleUpload={(file) => {dispatch(startUploading(file, certificadoDiscapacidad.idItem))}}
                                    handleDelete={idDocumentacion => {dispatch(deleteFileCertificadoDisca(idDocumentacion, certificadoDiscapacidad.idItem))}}
                                    documentacion={documentacionCertificado.map(item => ({
                                        ...item,
                                        idDocumentacion: item.idItem,
                                        idTipoDocumentaciones: 71
                                    }))}
                                    tipoDocumentacion={[{
                                        descripcionDocumentacion: "CERTIFICADO DISCAPACIDAD",
                                        idCategoria: CATEGORIAS_TIPO_DOCUMENTACION.DATOS_PERSONALES,
                                        idModulo: MODULO_APLICACION.AFILIACIONES,
                                        idTipoDocumentaciones: 71
                                    }]}
                                    permisoBaja={validarSoloUnPermiso(permisosUser, DISCAPACIDAD_PERMISOS.MENU.BAJA)}
                                    permisoAlta={
                                        validarSoloUnPermiso(permisosUser, DISCAPACIDAD_PERMISOS.MENU.ALTA) &&
                                        // certificadoDiscapacidad.fecha &&
                                        // (certificadoDiscapacidad.fechaVencimiento ||
                                        //     certificadoDiscapacidad.fechaActualizacion) &&
                                        documentacionCertificado.length < 1 
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={2} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <Fab
                                    style={{marginRight: "0.5em"}}
                                    variant='extended'
                                    color="primary"
                                    aria-label="add"
                                    size="medium"
                                    type="submit"
                                >
                                    <CheckIcon />
                                </Fab>
                                <DeleteButtonAbm 
                                    handleDelete={handleDelete}
                                    permiso={DISCAPACIDAD_PERMISOS.MENU.BAJA}
                                    mensajeEliminacion="¿Estás seguro que deseas eliminar este certificado?"
                                    Component={({handleClick}) => (
                                        <Fab
                                            style={{backgroundColor: "red", marginLeft: "0.5em"}}
                                            variant="extended"
                                            color="primary"
                                            aria-label="delete"
                                            size="medium"
                                            type="button"
                                            onClick={handleClick}
                                        >
                                            <DeleteForeverIcon />
                                        </Fab>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }

            {!certificadoDiscapacidad &&
                <Grid item xs={12} style={{padding: "1em", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <Typography 
                        variant='button' 
                        style={{textAlign: "center", marginBottom: "1em"}}
                    >
                        Documentacion Certificado de Discapacidad
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={handleCreateCertificado}
                    >
                        CREAR NUEVO CERTIFICADO
                    </Button>
                </Grid>
            }
        </ValidatorForm>
    )
}
